"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPadding = exports.setAutoMargin = exports.setMargin = void 0;
var styled_components_1 = require("styled-components");
var escapeCss_1 = __importDefault(require("../../helperFunctions/escapeCss"));
var spacing_1 = require("../../selectors/spacing");
var setSpacing = function (type, side, level) {
    switch (side) {
        case "all":
            return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ", ": ", " !important;\n      "], ["\n        ", ": ",
                " !important;\n      "])), escapeCss_1.default(type), function (props) {
                return spacing_1.spacingSelector(props, level);
            });
        case "x":
            return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        ", "-right: ", " !important;\n        ", "-left: ", " !important;\n      "], ["\n        ", "-right: ",
                " !important;\n        ", "-left: ",
                " !important;\n      "])), escapeCss_1.default(type), function (props) {
                return spacing_1.spacingSelector(props, level);
            }, escapeCss_1.default(type), function (props) {
                return spacing_1.spacingSelector(props, level);
            });
        case "y":
            return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        ", "-top: ", " !important;\n        ", "-bottom: ", " !important;\n      "], ["\n        ", "-top: ",
                " !important;\n        ", "-bottom: ",
                " !important;\n      "])), escapeCss_1.default(type), function (props) {
                return spacing_1.spacingSelector(props, level);
            }, escapeCss_1.default(type), function (props) {
                return spacing_1.spacingSelector(props, level);
            });
        default:
            return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        ", "-", ": ", " !important;\n      "], ["\n        ", "-", ": ",
                " !important;\n      "])), escapeCss_1.default(type), side, function (props) {
                return spacing_1.spacingSelector(props, level);
            });
    }
};
var setMargin = function (side, level) { return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), setSpacing("margin", side, level)); };
exports.setMargin = setMargin;
var setAutoMargin = function (side) {
    switch (side) {
        case "all":
        case null:
            return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        margin: auto !important;\n      "], ["\n        margin: auto !important;\n      "])));
        case "x":
            return styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        margin-right: auto !important;\n        margin-left: auto !important;\n      "], ["\n        margin-right: auto !important;\n        margin-left: auto !important;\n      "])));
        case "y":
            return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        margin-top: auto !important;\n        margin-bottom: auto !important;\n      "], ["\n        margin-top: auto !important;\n        margin-bottom: auto !important;\n      "])));
        default:
            return styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        margin-", ": auto !important;\n      "], ["\n        margin-", ": auto !important;\n      "])), escapeCss_1.default(side));
    }
};
exports.setAutoMargin = setAutoMargin;
var setPadding = function (side, level) { return styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), setSpacing("padding", side, level)); };
exports.setPadding = setPadding;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=spacing.js.map